module.exports = __webpack_public_path__ + "img/y-73.bc19df46.png";